import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';

const workorder: RouteRecordRaw = {
    path: 'work-orders/:workOrderId',
    name: 'site-workorder-detail',
    meta: {
        title: 'sitePage.workOrders',
        hidden: true,
        middlewares: [md.getWorkOrderInfo],
        allowedRoles: ['all'],
    },
    component: () => import('@/views/sites/workorder/WorkOrderDetail.vue'),
};

export default workorder;
